import React from "react"
import { Box, makeStyles } from "@material-ui/core"
import { useTheme } from "@material-ui/core/styles"
import CheckIcon from "@material-ui/icons/Check"

export const getColors = (theme) => [
	theme.palette.eventColor["C10"],
	theme.palette.eventColor["C20"],
	theme.palette.eventColor["C30"],
	theme.palette.eventColor["C40"],
	theme.palette.eventColor["C50"],
	theme.palette.eventColor["C60"],
	theme.palette.eventColor["C70"],
	theme.palette.eventColor["C80"],
	theme.palette.eventColor["C90"],
	theme.palette.eventColor["C100"],
]

const useStyles = makeStyles((theme) => ({
	selectedBox: {
		position: "relative",
		width: 30,
		height: 30,
		borderRadius: 4,
	},
	checkedBox: {
		transform: "translate(-50%, -59%)",
		position: "absolute",
		top: "50%",
		left: "50%",
	},
	wrapperBox: {
		cursor: "pointer",
	},
	gridContainer: {
		display: "grid",
		gridTemplateColumns: "repeat(var(--cols, 5), 1fr)", // defaulting to 5 columns
		gridTemplateRows: "repeat(var(--rows, 2), auto)",
		gridGap: "8px",
		width: 200,
	},
}))

const Color = ({ selectedColor = colors[0], setSelectedColor, rows = 2, cols = 5 }) => {
	const classes = useStyles()
	const theme = useTheme()
	const colors = getColors(theme)

	return (
		<Box style={{ "--rows": rows, "--cols": cols }} className={classes.gridContainer}>
			{colors.map((color, index) => (
				<Box key={index} onClick={() => setSelectedColor(color)} className={classes.wrapperBox}>
					<Box className={classes.selectedBox} bgcolor={color} boxShadow={selectedColor === color ? 4 : 0}>
						{selectedColor === color && (
							<Box className={classes.checkedBox}>
								<CheckIcon fontSize="small" />
							</Box>
						)}
					</Box>
				</Box>
			))}
		</Box>
	)
}

export default Color
